import { render, staticRenderFns } from "./VehiclePageMedia.vue?vue&type=template&id=4525d623&"
import script from "./VehiclePageMedia.vue?vue&type=script&lang=js&"
export * from "./VehiclePageMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports